import React from "react";
import { inject, observer } from "mobx-react";
import AccordionHeader from "blocks/accordion/AccordionHead";
import Collapsible from "react-collapsible";
import WorkshopContent from "./WorkshopContent";
import ModuleAccordionHeader from "../../create_workshop/create_module/ModuleAccordionHeader";
import HttpClient from "services/HttpClient";
import {
  M_COMPLETED,
  M_INPROGRESS,
  M_NOT_STARTED,
  M_SUBMITED,
  BUTTON_COMPLETE,
  BUTTON_PROGRESS,
  BUTTON_START,
  BUTTON_TAKE,
  TRAINEE,
  SUBMIT_MODULE,
  PROVIDER,
  BUTTON_NOT_STARTED
} from "./constants";
const COMPLETE_MODULE = "/api/v1/modules/complete_module?module_id=";
const GET_MODULE = "/api/v1/modules/";
@inject("workshopDetails")
@inject("alert")
@observer
export default class WorkshopAccordion extends React.Component {
  state = {
    description: '',
  };

  handler = (index, type) => {
    this.props.workshopDetails.changeOpenedType({
      type: type || this.props.type,
      index: (index || index === 0) ? index : this.props.index
    });
    this.props.getModuleDescription((index || index === 0) ? index : this.props.index);
    // new HttpClient().get(`${GET_MODULE}${this.props.workshopDetails.workshop.modules[this.props.index].id}`).then(response => {
    //   this.setState({description: response.body.module.description || ''});
    // });
  };

  focusModule = () => {
    setTimeout(this.bringModuleFocus, 600);
  };

  bringModuleFocus = () => {
    document
      .getElementsByClassName("Collapsible accordion-item is-active")[0]
      .scrollIntoView();
  };

  submitModule = () => {
    if (this.props.workshopDetails.role === TRAINEE) {
      new HttpClient()
        .post(
          SUBMIT_MODULE +
            this.props.workshopDetails.workshop.modules[this.props.index].id
        )
        .then(data => {
          this.props.workshopDetails.setSubmiteddModule(
            this.props.workshopDetails.workshop.modules[this.props.index].id
          );
          this.props.alert.success("Module successfully submitted");
          this.props.workshopDetails.changeOpenedType({
            type: "none",
            index: -1
          });
        });
    }
  };

  completeModule = () => {
    if (this.props.workshopDetails.role === PROVIDER) {
      new HttpClient()
        .post(
          COMPLETE_MODULE +
            this.props.workshopDetails.workshop.modules[this.props.index].id +
            "&user_id=" +
            this.props.workshopDetails.workshop.traine.id
        )
        .then(data => {
          this.props.workshopDetails.setCompletedModule(
            this.props.workshopDetails.workshop.modules[this.props.index].id
          );
          this.props.alert.success("Module successfully completed");
          this.props.workshopDetails.changeOpenedType({
            type: "none",
            index: -1
          });
        });
    }
  };

  render() {
    let opened = false;
    const {description} = this.props;
    if (this.props.type === "workshop")
      if (this.props.workshopDetails.openedType.type === this.props.type)
        opened = true;
    if (this.props.type === "module")
      if (
        this.props.workshopDetails.openedType.type === this.props.type &&
        this.props.workshopDetails.openedType.index === this.props.index
      )
        opened = true;

    let model;
    if (this.props.type === "workshop")
      model = this.props.workshopDetails.workshop;
    if (this.props.type === "module") {
      model = this.props.workshopDetails.workshop.modules[this.props.index];
    }

    let newCaption = document.createElement('div');
    const desc = (model && model.description) || description;
    newCaption.innerHTML = desc;
    newCaption = newCaption.textContent.substr(0,100) + '...';

    let header;
    if (this.props.type === "workshop")
      header = (
        <AccordionHeader
          label={model.title}
          caption={newCaption}
          withBtn={false}
          btn={{}}
          icon="ic-flag-ico"
        />
      );
    if (this.props.type === "module" && this.props.workshopDetails.role) {
      let state;
      switch (model.status) {
        case M_SUBMITED:
          state = BUTTON_START;
          break;
        case M_INPROGRESS:
          state = BUTTON_PROGRESS;
          break;
        case M_COMPLETED:
          state = BUTTON_COMPLETE;
          break;
        case M_NOT_STARTED:
          if (model.module_type === 'quiz' && !this.props.is_hidden) {
            state = BUTTON_TAKE;
          } else {
            state = BUTTON_NOT_STARTED;
          }
          break;
      }
      header = (
        <ModuleAccordionHeader
          label={model.title}
          number={this.props.index + 1}
          btn={state}
          caption={newCaption}
          handleDelete={this.handleDelete}
          removeBtn={true}
          moduleIdx={this.props.index}
          questions_length={this.props.questions_length}
          is_hidden={this.props.is_hidden}
        />
      );
    } else if (this.props.type === "module" && !this.props.workshopDetails.role)
      header = (
        <ModuleAccordionHeader
          label={model.title}
          number={this.props.index + 1}
          caption={newCaption}
          handleDelete={this.handleDelete}
          removeBtn={true}
          questions_length={this.props.questions_length}
          is_hidden={this.props.is_hidden}
        />
      );


    return (
      <Collapsible
        className="accordion-item"
        openedClassName="accordion-item is-active"
        trigger={header}
        open={opened}
        handleTriggerClick={this.handler}
        onOpen={() => this.focusModule()}
      >
        <WorkshopContent
          type={this.props.type}
          index={this.props.index}
          moduleType={this.props.moduleType}
          description={desc}
          is_hidden={this.props.is_hidden}
          questions_length={this.props.questions_length}
          handleTriggerClick={this.handler}
          onOpen={this.focusModule}
        />

        {this.props.type === "module" &&
        this.props.workshopDetails.role === TRAINEE &&
        model.module_type === "question" ? (
          this.props.workshopDetails.modulesState.get(model.id)
            .canSetModuleSubmit ? (
            model.status !== "module_completed" &&
            model.status !== "module_submited" && (
              <div className="accordion-footer">
                <div className="btn prime bordered" onClick={this.submitModule}>
                  SUBMIT MODULE
                </div>
              </div>
            )
          ) : (
            <div className="accordion-footer">
              <p className="error-message">
                All questions must be answered before you can submit this
                module.
              </p>
              <div className="btn bordered empty grey-empty">SUBMIT MODULE</div>
            </div>
          )
        ) : null}

        {this.props.type === "module" &&
          this.props.workshopDetails.role === TRAINEE &&
          model.module_type === "quiz" &&
          null}

        {this.props.type === "module" &&
        this.props.workshopDetails.role === PROVIDER &&
        model.module_type === "question" ? (
          this.props.workshopDetails.modulesState.get(model.id)
            .canSetModuleComplete ? (
            model.status === "module_completed" ? (
              <div className="accordion-footer">
                <div
                  className="btn green bordered"
                  onClick={this.submitModule}
                  style={{ backgroundColor: "#4caf50", color: "white" }}
                >
                  COMPLETED
                </div>
              </div>
            ) : (
              <div className="accordion-footer">
                <div
                  className="btn prime bordered"
                  onClick={this.completeModule}
                >
                  Complete MODULE
                </div>
              </div>
            )
          ) : (
            <div className="accordion-footer">
              <p className="error-message">
                Please give feedback to all Trainee Responses
              </p>
              <div className="btn bordered empty grey-empty">
                COMPLETE MODULE
              </div>
            </div>
          )
        ) : null}

        {this.props.type === "module" &&
          this.props.workshopDetails.role === PROVIDER &&
          model.module_type === "quiz" &&
          null}
      </Collapsible>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/ModelAccordion.jsx